import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { useMemo } from 'react';
import { DialogTrigger } from 'react-aria-components';
import PopoverContextProvider from './popover-context.esm.js';
import { PopoverCore } from './popover-core.esm.js';
import Dialog from '../dialog/primitives/dialog.esm.js';
import OverlayArrow from '../overlay-arrow/overlay-arrow.esm.js';

var _excluded = ["isOpen", "defaultOpen", "onOpenChange", "className", "children", "showArrow", "color", "radius", "anchorElement", "maxWidth", "padding", "scrollLockElement"];
function PrivatePopover(_ref) {
  var isOpen = _ref.isOpen,
    defaultOpen = _ref.defaultOpen,
    onOpenChange = _ref.onOpenChange;
    _ref.className;
    var children = _ref.children,
    showArrow = _ref.showArrow,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'base' : _ref$color,
    radius = _ref.radius,
    anchorElement = _ref.anchorElement,
    maxWidth = _ref.maxWidth,
    padding = _ref.padding,
    scrollLockElement = _ref.scrollLockElement,
    props = _objectWithoutProperties(_ref, _excluded);
  //This has to be memoized, a new jsx prop would incur multiple rerenders on context provider update
  var contextValue = useMemo(function () {
    return {
      color: color,
      padding: padding,
      radius: radius,
      scrollLockElement: scrollLockElement
    };
  }, [color, padding, radius, scrollLockElement]);

  /*
   * TODO: will look more closely at this in future
   * Our mobile support should be expanded on as shown in: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-spectrum/dialog/src/DialogTrigger.tsx
   * TLDR: Popovers should be modals/trays in mobile, in addition mobile should rely on OnPress instead of onHover for popovers
   */
  return /*#__PURE__*/React__default.createElement(PopoverContextProvider, {
    value: contextValue
  }, anchorElement ? /*#__PURE__*/React__default.createElement(DialogTrigger, {
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, anchorElement, /*#__PURE__*/React__default.createElement(PopoverCore, props, showArrow ? /*#__PURE__*/React__default.createElement(OverlayArrow, null) : null, /*#__PURE__*/React__default.createElement(Dialog, {
    maxWidth: maxWidth
  }, children))) : /*#__PURE__*/React__default.createElement(PopoverCore, _extends({}, props, {
    isOpen: isOpen,
    defaultOpen: defaultOpen
  }), showArrow ? /*#__PURE__*/React__default.createElement(OverlayArrow, null) : null, /*#__PURE__*/React__default.createElement(Dialog, {
    maxWidth: maxWidth
  }, children)));
}
function Popover(props) {
  return /*#__PURE__*/React__default.createElement(PrivatePopover, props);
}

export { Popover, PrivatePopover, Popover as default };
//# sourceMappingURL=popover.esm.js.map
